import { useTranslation } from 'react-i18next'

import { Product } from '@shared/generated'

import styles from './styles.module.scss'

export interface ProductPropertiesProps {
  product: Product;
}

export default function ProductProperties (props: ProductPropertiesProps) {
  const { t } = useTranslation('product')
  const { product } = props
  const properties = product.productProperties

  return (
    <div className={styles.root}>
      {properties?.calories != null && (
        <div className={styles.root__item}>
          <b>{properties.calories}</b>
          <h4>{t('nutrition.calories')}</h4>
        </div>
      )}
      {properties?.proteins != null && (
        <div className={styles.root__item}>
          <b>{properties.proteins}</b>
          <h4>{t('nutrition.proteins')}</h4>
        </div>
      )}
      {properties?.fats != null && (
        <div className={styles.root__item}>
          <b>{properties.fats}</b>
          <h4>{t('nutrition.fats')}</h4>
        </div>
      )}
      {properties?.carbohydrate != null && (
        <div className={styles.root__item}>
          <b>{properties.carbohydrate}</b>
          <h4>{t('nutrition.carbohydrates')}</h4>
        </div>
      )}
    </div>
  )
}
